import { render, staticRenderFns } from "./SupportOptions.vue?vue&type=template&id=559d1cc8&scoped=true&"
import script from "./SupportOptions.vue?vue&type=script&lang=js&"
export * from "./SupportOptions.vue?vue&type=script&lang=js&"
import style0 from "./SupportOptions.vue?vue&type=style&index=0&id=559d1cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d1cc8",
  null
  
)

export default component.exports